import { render } from "./CollectionFilter.vue?vue&type=template&id=4d1fddde"
import script from "./CollectionFilter.vue?vue&type=script&lang=js"
export * from "./CollectionFilter.vue?vue&type=script&lang=js"

import "./CollectionFilter.vue?vue&type=style&index=0&id=4d1fddde&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__